import ServiceCRUD from '../../../../../../services/ServiceExportFLEXCHAT';
import { toast } from 'react-toastify';
import { apiChatExport as http } from '../../../../../../http';

class ConversationExportService extends ServiceCRUD {
  constructor() {
    super('relatorio');
  }

  async downloadReportXlsxStream(
    typeOfReport,
    fileExtension,
    queryParams = {},
    jwt
  ) {
    if (!typeOfReport || !fileExtension || !jwt) {
      toast.error(`Algo deu errado ao fazer o download do relatório.`);
      throw new Error(
        'Missing required parameters: typeOfReport, fileExtension, and jwt are required.'
      );
    }
    const fileTypePath = 'xlsx';
    return http.get(`${this.path}/${typeOfReport}/${fileTypePath}`, {
      params: {
        ...queryParams,
        jwt: localStorage.getItem('token'),
        request_by: localStorage.getItem('login')
      },
      responseType: 'arraybuffer'
    });
  }
}

export default new ConversationExportService();
